// extracted by mini-css-extract-plugin
module.exports =  {"appheader":"PageHeaderComponent_appheader__BVJ-n","applicationLogoTitleLink":"PageHeaderComponent_applicationLogoTitleLink__S5oLP"};